module.exports = __webpack_public_path__ + "static/img/007_2_punkt.30af7db1.jpg";